// import IconButton  from '@material-ui/core/IconButton';
// import EditIcon  from '@material-ui/icons/Edit';
import { useState, useEffect } from 'react';
import { FaEdit, FaFileUpload, FaGraduationCap } from 'react-icons/fa';
import M from 'materialize-css/dist/js/materialize.min';
import TeacherLayout from "./TeacherLayout";
import { connect } from 'react-redux';
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import { useFirebase } from 'react-redux-firebase';
import { addProfileAction } from '../../../Firebase/actions/addProfileAction';
import CustomizedSnackbars from "../../Feedback";
import SubLoading from '../../Loading/SubLoading';

const TeacherProfile = ({  addProfileAction, addProfileSuccess, addProfileError, admins, auth, resetSuccess }) => {
    const [selectFile, setSelectedFile ] = useState(null);
    const [preview, setPreview ] = useState(null);
    const [ error, setError ] = useState(null);

    const [ openFeedback, setOpenFeedback ] =  useState(false); 
    const [ feedbackText, setFeedbackText ] =  useState(''); 
    const [ severity, setSeverity ] =  useState(null); 

    const firebase = useFirebase();

    // simualting student object from db
    let teacher;
    if(auth.uid) {
        let admin;
        
        if (admins) {
            
            admin = admins.filter((item) => {
                return item.id === auth.uid
            });  
            
            teacher = admin[0];     //console.log(output, auth);
            
        }     
    }
    // ======

    const handlEditPic = () => {
        document.querySelector('#editInput').click();
    }


    const setCurrentImage = (e) => {
        if (!teacher.imageUrl) {
            e.target.src="img/placeholder.svg";
        } else {
            let url = teacher.imageUrl;
            e.target.src={url};
        }
        
    }

    const upDateImage = () => {

        // upadate or upload image and if done 
        
        const storageRef = firebase.storage().ref(`profiles/${teacher.idNumber}`);


        storageRef.put(selectFile).on('state change', (snap) => {
            document.getElementById('Btn').classList.add('is-loading');
        }, (err) => {
            document.getElementById('Btn').classList.remove('is-loading');
           //console.log(err)
            setError('Error Please Try Again.');
        }, async () => {

            const uploadedFileUrl = await storageRef.getDownloadURL();
            //console.log(uploadedFileUrl);
            document.getElementById('Btn').classList.remove('is-loading');
                let data = {
                    collection: 'admins',
                    id: teacher.id,
                    url: uploadedFileUrl
    
                }
                addProfileAction(data);
        }); 
    }

    //profile toggler
    let imgTag;
    if(teacher) {
        if(teacher.imageUrl !== undefined || !preview) {
            imgTag = <img  src={teacher.imageUrl}  alt="ProfilePicture" className="logo-form grey lighten-3"  />
        }
    
        if(teacher.imageUrl === undefined || preview) {
            imgTag =  <img src={preview} onError={(e) => setCurrentImage(e)} alt="ProfilePicture"  className="logo-form grey lighten-3" />
        }
    }
   
    

    useEffect(() => {
        //tooltip init
        var tp = document.querySelector('.tooltipped');
        M.Tooltip.init(tp, {});


        if(selectFile) {
            if(selectFile.type.substr(0,5) !== "image") {
                setSelectedFile(null);
            }
        }

        if(selectFile) {
            if(selectFile.size > 2000000) {
                document.getElementById('Btn').classList.remove('is-loading');
                setError('Sorry, Image size cannot be larger than 2MB.');
                setSelectedFile(null);
            } else {
                setError(false);
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPreview(reader.result);
                }
                reader.readAsDataURL(selectFile);
            }       
        } else {
            setPreview(null);
        }

        if(addProfileSuccess) {
            //on success
            setFeedbackText('Profile Updated.');
            setSeverity('success');
            setOpenFeedback(true);
            setPreview(null);
            setSelectedFile(null);

            resetSuccess();
            
        }

        if(addProfileError) {
            document.getElementById('Btn').classList.remove('is-loading');
            setFeedbackText('Error occured.');
            setSeverity('error');
            setOpenFeedback(true);
        }   
    }, [selectFile, addProfileSuccess, addProfileError, resetSuccess]);


    return ( 
        <TeacherLayout>
            <div className="row pt-5">
                {
                    teacher ? (
                        <>
                        <div className="col s12 m8 l5 mb-4">
                            <div className="container">
                                <div className="center">
                                {imgTag}
                                {
                                    // true  && (
                                    //     <IconButton 
                                    //         onClick={handlEditPic} 
                                    //         className="tooltipped grey lighten-4 py-1 px-1 mb-4 edit-icon" size="small"
                                    //         data-tooltip="Edit Profile Picture"
                                        
                                    //     >
                                    //         <EditIcon className="main-blue"  />
                                    //     </IconButton>
                                    // )
                                }
                                </div>
                                <input 
                                    type="file" 
                                    onChange={(e) => setSelectedFile(e.target.files[0])}
                                    hidden="hidden"
                                    id="editInput"
                                    accept="image/*"
                                />
                                <div className="center mb-5">
                                    {
                                        selectFile !== null && (
                                            <div 
                                                className="button is-success is-small border-none"
                                                onClick={upDateImage}
                                                id="Btn"
                                            >
                                                <span className="icon">
                                                    <FaFileUpload color="white"/>
                                                </span>
                                                <span className="white-text">Update</span>
                                            </div>
                                        )
                                    }
                                    <div 
                                        onClick={handlEditPic} 
                                        className="button is-success is-small border-none"
                                        data-tooltip="Edit Profile Picture"
                                    >
                                        <span className="icon">
                                            <FaEdit color="white"/>
                                        </span>
                                        <span className="white-text">Edit</span>
                                    </div>
                                    {
                                        error && <p className="main-color-text tiny-text mt-5">{error}</p>
                                    }
                                </div>
                            </div>
                            
                            <div className="student-name center">
                                <p className="is-size-5">{teacher.forenames} {teacher.surname}</p>
                                <p className="is-size-6 grey-text text-lighten-1">{teacher.email}</p>
                            </div>
                        </div>
                        <div className="col s12 m8 l5">
                            <h5 className="title is-size-5-touch has-text-weight-semibold mb-2 grey-text text-darken-3">Personal Information</h5>
                            <div className="divider mb-5"></div>
                            <div className="dtails">
                                <p className="is-size-6 grey-text text-darken-2 mb-3">Date of Birth: {teacher.dob}</p>
                                <p className="is-size-6 grey-text text-darken-2 mb-3">National ID: {teacher.idNumber}</p>
                                <p className="is-size-6 grey-text text-darken-2 mb-3">Gender: {teacher.gender}</p>
                                
                            </div>
                        </div>
                        </>
                    ): (
                     <SubLoading />
                    )
                }
            </div>
            {
                teacher && (
                    <div className="container">
                        <ul className="collection with-header mt-6">
                            <li className="collection-header is-size-5">Your Qualifications</li>
                            {
                                teacher.qualifications && teacher.qualifications.map(item => (
                                    <li className="collection-item" key={item}>
                                        <FaGraduationCap fontSize="1.2rem"  className="mr-3 grey-text text-darken-2"/>
                                        <span className="is-size-6 grey-text text-darken-2">{item}</span>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>

                )
            }
            <CustomizedSnackbars openSuccess={openFeedback} feedbackText={feedbackText} severity={severity} />
        </TeacherLayout>
     );
}

const mapStateToProps = (state) => {
    //console.log(state)
    return {
        addProfileSuccess: state.addProfile.addProfileSuccess,
        addProfileError: state.addProfile.addProfileError,
        admins: state.firestore.ordered.admins,
        auth: state.firebase.auth,

    }
    
}
 

const mapDispatchToProps = (dispatch) => {
    return {
        addProfileAction: (data) => dispatch(addProfileAction(data)),
        resetSuccess: () => dispatch({ type: "ADD_PROFILE", success: false })
    };
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
        firestoreConnect((ownProps) => [
            {
                collection: "admins", 
            },
    ])
)(TeacherProfile);

 